import {
  ApiGetRequest,
  //   ApiPostRequest,
  //   ApiPutRequest,
  //   ApiPostRequest,
  //   ApiDeleteRequest,
  //   ApiPutRequest,
} from '../../../api';
// import { _ } from 'vue-underscore';
// import { showNotif } from '../../notification';
import moment from 'moment-mini';

export const state = {
  data: {
    title: 'Buku Besar',
    title_form: 'Form Buku Besar',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'Buku Besar',
        href: '/adm/fin/buku-besar/buku-besar',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_journal_detail',
    filter_account: '',
    filter_account_name: '',
    sortDesc: true,
    fields: [
      {
        key: 'date_journal',
        label: 'Tanggal',
        sortable: true,
      },
      {
        key: 'code_journal',
        label: 'Referensi',
        sortable: true,
      },
      {
        key: 'description',
        label: 'Catatan',
        sortable: true,
      },
      {
        key: 'department',
        label: 'Department',
      },
      {
        key: 'debet',
        label: 'Debet',
      },
      {
        key: 'kredit',
        label: 'Kredit',
      },
      {
        key: 'aksi',
        label: 'Aksi',
      },
    ],
    form: {
      code_inv_depo: '',
      date_inv: '',
      id_department: '',
      id_currency: '',
      remark: '',
      total_cost: '',
      acc_other_cost: '',
      other_cost: '',
      acc_disc_final: '',
      disc_final: '',
      total_hpp: '',
      total_ppn10: '',
      total_pph23: '',
      total_invoice: '',
      acc_payment: '',
      total_payment: '',
      id_journal: '',
      term_payment: '',
      status_inv: '',
      details: [],
    },
    journal: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeBukuBesar(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getBukuBesar({ commit, state }) {
    const { data } = state;

    if (data.filter_account && data.filter_account !== '') {
      commit('changeBukuBesar', {
        loading: true,
      });

      let params = {
        q: data.search,
        limit: data.limit,
        page: data.page,
        sort: data.sortBy,
        order: data.sortDesc ? 'desc' : 'asc',
        account: data.filter_account,
      };

      let result = await ApiGetRequest('fin/buku-besar', params);
      commit('changeBukuBesar', {
        items: !result.error ? result.data.object : [],
        total: !result.error ? result.data.total : 0,
        loading: false,
      });

      return !result.error ? true : false;
    }
  },

  async getDetailBukuBesar({ commit, state }, payload = null) {
    commit('changeBukuBesar', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/buku-besar/${payload.id}`);
    commit('changeBukuBesar', {
      loading: false,
    });

    if (!result.error) {
      commit('changeBukuBesar', {
        form: {
          ...data.form,
          ...result.data.object,
          date_trans:
            result.data.object && result.data.object.date_trans
              ? moment(result.data.object.date_trans).format('DD/MM/YYYY')
              : '',
        },
      });

      return true;
    }

    return false;
  },
};
